import { Button } from '../../modules/design-system';

export interface MyPacksFooterProps {
  onFaq?: () => void;
  onTerms?: () => void;
  onPrivacy?: () => void;
}

const LINKS: { label: string; key: 'faq' | 'terms' | 'privacy' }[] = [
  { label: 'FAQ', key: 'faq' },
  { label: 'Terms & Conditions', key: 'terms' },
  { label: 'Privacy Policy', key: 'privacy' },
];

/**
 * Footer with three placeholder links — FAQ, Terms & Conditions, Privacy
 * Policy. Figma 706:1839 — Inter Regular 13px, colour #DCDCDC, 24px gap,
 * −0.1px tracking. Wired to optional callbacks so the parent can route
 * each click later; without handlers the links render as plain text.
 */
export function MyPacksFooter({ onFaq, onTerms, onPrivacy }: MyPacksFooterProps) {
  const handlers: Record<'faq' | 'terms' | 'privacy', (() => void) | undefined> = {
    faq: onFaq,
    terms: onTerms,
    privacy: onPrivacy,
  };

  return (
    <footer
      data-co-component="MyPacksFooter"
      className="
        flex flex-wrap items-center justify-center
        gap-x-4 gap-y-1 px-4 py-6
        @[600px]:gap-x-[24px]
      "
      style={{
        fontFamily: 'var(--co-MyPacksFooter-fontFamily), Inter, system-ui, sans-serif',
      }}
    >
      {LINKS.map((link) => {
        const onClick = handlers[link.key];
        return (
          <Button
            key={link.key}
            variant="ghost"
            size="md"
            onClick={onClick}
            disabled={!onClick}
            className="px-0"
            style={{
              color: 'var(--co-MyPacksFooter-linkColor, #DCDCDC)',
              fontSize: 'var(--co-MyPacksFooter-linkSize, 13px)',
              lineHeight: '20px',
              letterSpacing: '-0.1px',
            }}
          >
            {link.label}
          </Button>
        );
      })}
    </footer>
  );
}
